
first_of_all_init();
iloader_init();
gsap_init();

$(function () {
    ts = (new Date()).getTime();

    responsive_init();

    $("body").addClass("ready").removeClass("no-transition");

    init_event_handlers();
    bind_widgets();

    te = (new Date()).getTime();
    console.log("On-Ready Load Time: ", te - ts);
});

$(window).on('load', function () {
    ScrollTrigger.refresh();
});

$(window).on('scroll load', function () {
    scroll_animations();
});

$(window).on("resize", function (e) {
    responsive_update(null, true);
    scroll_animations();
});

function first_of_all_init() {
    if (!areClipPathShapesSupported()) {
        $('html').addClass('no-clip-paths');
    }

    window['isMobile'] = _isMobile();
    function _isMobile() {
        return $(window).width() < 768;
    }

    // window['isWide'] = _isWide();
    // function _isWide() {
    //     return $(window).width() > 1600;
    // }

    window['isLandscape'] = _isLandscape();
    function _isLandscape() {
        return screen.availHeight < screen.availWidth;
    }

    $('body').on("responsive-update", function (e) {
        isMobile = _isMobile();
        //isWide = _isWide();
        isLandscape = _isLandscape();
        $(this).toggleClass('isMobile', isMobile).toggleClass('isLandscape', isLandscape);
    });

    // $('body').on("responsive-update", function (e) {
    //     $('.js-compensate-mt').each(function(){
    //         var $c = $(this).find('.container').first();
    //         var value = ($c.height() - $(this).height())/2;
    //         $(this).css('margin-top', value);
    //     });
    // });

    $('body').on("responsive-update", function (e) {
        $('.js-gsap-goto-anchor').each(function(){
            var $s = $(this).closest('.js-gsap-goto-anchor-section');
            //var $c = $s.find('.container').first();
            var s_height = $s.outerHeight();
            var height = Math.max(window.innerHeight, s_height);
            var value = (s_height - height)/2;
            $(this).height(height);
            // var delta = 1;
            // if ($(this).data('gsap-goto-anchor-trigger-delta')) {
            //     var $t = $s.find('.gsap-trigger');
            //     var t_height = $t.height();
            //     delta = $(this).data('gsap-goto-anchor-trigger-delta');
            //     var scroll_height = window.innerHeight;
            //     if ($(this).data('gsap-goto-anchor-trigger-scroll-height')) {
            //         scroll_height = $(this).data('gsap-goto-anchor-trigger-scroll-height')*window.innerHeight;
            //     }
            //     value = $s.offset().top - $t.offset().top + t_height/2 - scroll_height*delta;
            //     //value = value*delta;
            //     //console.log('value', value, $s.offset().top, $t.offset().top, t_height*delta);
            // }
            // console.log('value', value);
            $(this).css('margin-top', value);
        });
    });
}

function init_event_handlers() {
    fix_touch_hovers();
    fix_100vh_init();
    icons_load();
    goto_init();
    scroll_animations(true);
    blazy_init();
    click_touch_init();
    header_init();
    tabs_init();
    toggle_element_init();
    misc_init();
    form_process_init();
}

function bind_widgets(context) {
    img_to_bg(null, context);
    fancybox_init();
    textfield_init(null, context);
    textfield_autosize_init(null, context);
    input_spin_init();
    mask_init(context);
    validate_init(context);
    slider_init(null, context);
    tabs_scroll_init();
}